// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const Container = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    & > span {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
`;

interface IIconContainerProps {
    $color: string;
}

export const IconContainer = styled.div<IIconContainerProps>`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 12px;
    height: 12px;

    border-radius: 100%;

    color: ${({ $color }) => $color};

    margin-right: 10px;

    > svg {
        width: 100%;
        height: 100%;
    }
`;
